var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPicture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.301 24.301",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.037,28.8H26.264A2.553,2.553,0,0,0,28.8,26.264V7.037A2.553,2.553,0,0,0,26.264,4.5H7.037A2.553,2.553,0,0,0,4.5,7.037V26.264A2.553,2.553,0,0,0,7.037,28.8Zm.454-21.31H25.784V19.455l-3.739-3.739a.548.548,0,0,0-.774,0l-2.777,2.751-4.753-4.78a.548.548,0,0,0-.774,0L7.491,19.161Zm9.56,3.926a2.11,2.11,0,1,1,2.11,2.11A2.1,2.1,0,0,1,17.051,11.417Z",
    transform: "translate(-4.5 -4.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPicture);
export default __webpack_public_path__ + "static/media/picture.cdedec325cdc878a4423f49dc0e28ea8.svg";
export { ForwardRef as ReactComponent };